// Demo-only flow state (mock). Shares the chosen photo + optional details across the
// AI-log flow screens via sessionStorage. No backend, no persistence beyond the session.
const PHOTO = 'ailog_demo_photo';
const DETAILS = 'ailog_demo_details';

export const setFlowPhoto = (url) => { try { sessionStorage.setItem(PHOTO, url || ''); } catch (e) { /* noop */ } };
export const getFlowPhoto = () => { try { return sessionStorage.getItem(PHOTO) || ''; } catch (e) { return ''; } };
export const setFlowDetails = (t) => { try { sessionStorage.setItem(DETAILS, t || ''); } catch (e) { /* noop */ } };
export const getFlowDetails = () => { try { return sessionStorage.getItem(DETAILS) || ''; } catch (e) { return ''; } };

const DRAFT = 'ailog_demo_draft';
export const setFlowDraft = (obj) => { try { sessionStorage.setItem(DRAFT, obj ? JSON.stringify(obj) : ''); } catch (e) { /* noop */ } };
export const getFlowDraft = () => { try { const v = sessionStorage.getItem(DRAFT); return v ? JSON.parse(v) : null; } catch (e) { return null; } };

// Downscaled JPEG data-URL of the chosen photo, sent to /api/ai-log/draft/image. Empty = sample mode.
const IMG = 'ailog_image_b64';
export const setFlowImageB64 = (b) => { try { sessionStorage.setItem(IMG, b || ''); } catch (e) { /* noop */ } };
export const getFlowImageB64 = () => { try { return sessionStorage.getItem(IMG) || ''; } catch (e) { return ''; } };
